import { axiosInstanceRentablo, axiosInstanceRentabloV1 } from "@rentablo/api";
import { LoginToken } from "../model";

export interface LoginParams {
  email: string;
  password: string;
}

export const getImpersonatedUserToken = async (
  token: string | undefined,
  id: number
) => {
  const { data } = await axiosInstanceRentabloV1.post<LoginToken>(
    `/users/${id}/impersonate`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const impersonateSessionToken = async (email: string) => {
  await axiosInstanceRentablo.post<LoginToken>(
    `/login/impersonate`,
    {},
    {
      withCredentials: true,
      params: {
        username: email,
      },
    }
  );
};

export const endSessionImpersonation = async () => {
  await axiosInstanceRentablo.post<LoginToken>(
    `/logout/impersonate`,
    {},
    {
      withCredentials: true,
    }
  );
};
